import { dehydrate, QueryClient } from '@tanstack/react-query';
import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import TerapiRegeneratif from 'src/containers/TerapiRegeneratif';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));

const StemCell = () => {
	return (
		<>
			<HeadC
				title="Manfaat Stem Cell: Inovasi Kesehatan untuk Penyakit Berat"
				description={
					'Pelajari manfaat stem cell untuk kesehatan dan kecantikan! ' +
					'Temukan inovasi terbaru dalam terapi sel punca ' +
					'yang dapat membantu regenerasi dan peremajaan tubuh Kamu.'
				}
			/>
			<TerapiRegeneratif />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	const queryClient = new QueryClient();

	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	return {
		props: {
			dehydratedState: dehydrate(queryClient),
			isDrawerOnly: true,
		},
	};
});

export default StemCell;
